import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthStateService } from './auth-state.service';
import { inject } from '@angular/core';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authStateService = inject(AuthStateService);
  const router = inject(Router);

  if(authStateService.isAuthenticated()){
    return true;
  }else{
    return router.createUrlTree(['/']);
  }
};


